import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQueryWithErrorHandling } from './errors'

export const baseApi = createApi({
  baseQuery: baseQueryWithErrorHandling,
  endpoints: () => ({}),
  tagTypes: ['USER', 'ORDER_LIST', 'CUSTOMER_LIST']
})
